import React, { Suspense, useState, useEffect } from 'react';
/// Components
import Index from './jsx/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// action
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./css/style.css";
import Loading from "./jsx/common/Loading";
import { ErrorBoundary } from "react-error-boundary";
import Error500 from "./jsx/pages/Error500";
//require('dotenv').config();
import axios from 'axios';
import { sendPushDeviceToken } from "./jsx/common/utils";
import { store } from './store/store';
import indexedDBService from './services/IndexedDBService';
import { useHandleError } from './services/AlertService';
import { setUnauthorizedHandler } from './services/AxiosInstance';

window.receiveDeviceToken = (token, apiKey) => {
  if (process.env.REACT_APP_GOTOVO_API_KEY === apiKey) {
    sendPushDeviceToken(token, 'apple')
  }
};

window.receiveAndroidDeviceToken = (token, apiKey) => {
  if (process.env.REACT_APP_GOTOVO_API_KEY === apiKey) {
    sendPushDeviceToken(token, 'android').then(() =>
      window.ReactNativeWebView.postMessage(JSON.stringify('Token saved'))
    ).catch(() =>
      window.ReactNativeWebView.postMessage(JSON.stringify('Token error'))
    )
  } else {
    window.ReactNativeWebView.postMessage(JSON.stringify('Wrong API key'));
  }
};

window.restaurantConfig = async (apiKey) => {
  if (process.env.REACT_APP_GOTOVO_API_KEY === apiKey) {
    const tokenDetails = await indexedDBService.getUserData('userDetails');
    window.ReactNativeWebView.postMessage(JSON.stringify(tokenDetails));
  }
};

window.setIsTerminal = async (id, apiKey) => {
  if (process.env.REACT_APP_GOTOVO_API_KEY === apiKey) {
    await indexedDBService.setSetting('isTerminal', id);
  }
};

window.removeIsTerminal = async (apiKey) => {
  if (process.env.REACT_APP_GOTOVO_API_KEY === apiKey) {
    await indexedDBService.removeSetting('isTerminal');
  }
};

window.getUserDetails = async () => {
  return await indexedDBService.getUserData('userDetails');
};

window.updateUserDetails = async (newUserDetails) => {
  if (newUserDetails) {
    await indexedDBService.setUserData('userDetails', newUserDetails);
    window.location.reload();
  }
};

function App(props) {
  const [error, setError] = useState(null);
  const handleError = useHandleError();

  useEffect(() => {
    setUnauthorizedHandler((errors, resp) => {
      handleError(errors, resp);
    });
  }, [handleError]);

  const logError = (error, info, history) => {
    setError({ error, info });
    if (window.location.host === 'test.gotovo.app' || window.location.host === 'gotovo.app') {
      if (!(/Loading chunk [\d]+ failed/.test(error.message))) {
        let errorText = `${error.message} \n\n ${JSON.stringify(history.location)} \n\n ${JSON.stringify(store.getState().orders)} \n\n ${`${store.getState().auth.auth?.userData?.id} - ${store.getState().auth.auth?.userData?.first_name} ${store.getState().auth.auth?.userData?.last_name}`}`;

        // Telegram limits messages to 4096 characters
        if (errorText.length > 4000) {
          errorText = errorText.substring(0, 4000) + '\n\n...[TRUNCATED]';
        }

        axios.post(`https://api.telegram.org/bot${process.env.REACT_APP_TELEGRAM_ERROR_BOT}/sendMessage`, {
          chat_id: 140859376,
          text: errorText
        }).catch(err => console.error("Failed to send Telegram error report:", err));
      }
    }
  };

  return (
    <ErrorBoundary FallbackComponent={() => <Error500 error={error} />} onError={(e, i) => logError(e, i, props.history)}>
      <Suspense fallback={<Loading whole={true} />}>
        <Index isAuthenticated={props.isAuthenticated} history={props.history} />
      </Suspense>
    </ErrorBoundary>);
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App)); 
